import dump from "@/modules/css-var-dump";
import { kebabCase } from "change-case";
import { Validator } from '@cfworker/json-schema';
import themeSchema from "@/assets/theme/theme-schema.json";
import themeConfiguration from "@/assets/theme/themes.json";

export interface Theme {
    name: string,
    config: any
}

export const themeConfig = themeConfiguration;
export const themeValidator = new Validator(Object(themeSchema));
export const themes: Theme[] = [];

for (const theme of themeConfig.themes) {
    const result = themeValidator.validate(theme);
    if (!result.valid || result.errors.length !== 0) {
        const errorMessage = "The theme " + theme.name + " is not valid.";
        console.error(errorMessage + "Validation result: ");
        console.error(result);
        throw new Error(errorMessage);
    }
    const outputTheme = { ...theme };
    // outputTheme.name = capitalCase(outputTheme.name);
    themes.push(outputTheme);
}

export function getTheme(name: string | null): Theme | undefined {
    return themes.find(theme => theme.name === name);
}

function setThemeRaw(theme: Theme, outputElement: HTMLElement): void {
    dump(Object.entries(theme.config), outputElement, key => "--" + kebabCase(key));
}

export function setTheme(theme: Theme | undefined, outputElement: HTMLElement = document.documentElement): void {
    if (theme) {
        setThemeRaw(themeConfig.default, outputElement);
        setThemeRaw(theme, outputElement);
        localStorage.setItem("currentTheme", theme.name);
    }
}

export function getCurrentTheme() {
    return localStorage.getItem("currentTheme");
}

export function autoThemeSetup(): void {
    const currentTheme = getCurrentTheme();
    if (currentTheme) {
        console.log("User preference is defined");
        setTheme(getTheme(currentTheme));
    } else if (window.matchMedia) {
        if (window.matchMedia("(prefers-color-scheme: light)").matches) {
            console.log("User prefers a light theme");
            setTheme(getTheme("light"));
        } else if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
            console.log("User prefers a dark theme");
            console.log(getTheme("dark"));

            setTheme(getTheme("dark"));
        } else {
            console.log("User preference is not defined");
            setTheme(getTheme("light"));
        }
    } else {
        console.log("matchMedia is not supported");
        setTheme(getTheme("light"));
    }
}
